import assert from 'minimalistic-assert';
import Address from '../address/index.js';
import { ModelIdSymbol } from '../constants.js';
import { createIsInstance } from '../utils.js';
export default class AddressSet {
    _data;
    constructor() {
        this._data = new Map();
    }
    static get [ModelIdSymbol]() {
        return 'AddressSet';
    }
    static _isInstance = createIsInstance(AddressSet);
    static [Symbol.hasInstance](x) {
        return this._isInstance(x);
    }
    static isInstance = AddressSet[Symbol.hasInstance];
    static EMPTY = AddressSet.fromArray([]);
    static fromArray(arr) {
        const vals = arr.map((addr) => {
            if (typeof addr === 'string')
                return Address.create(addr);
            if (addr instanceof Address)
                return addr;
            if (typeof addr === 'object')
                return Address.fromJSON(addr);
            console.dir(addr);
            throw new Error(`AddressSet#fromArray(): unknown type`);
        });
        const ac = new AddressSet();
        for (const addr of vals) {
            ac._data.set(addr.address, addr);
        }
        return ac;
    }
    add(address) {
        assert(Address.isAddress(address), 'Must be an instance of an Address.');
        const ac = new AddressSet();
        ac._data = new Map(this._data);
        ac._data.set(address.address, address);
        return ac;
    }
    delete(address) {
        return this.remove(address);
    }
    get(address) {
        return this._data.get(String(address));
    }
    has(address) {
        return !!this._data.get(String(address));
    }
    remove(address) {
        const addrObj = this.get(address);
        if (!addrObj)
            return this;
        const ac = new AddressSet();
        ac._data = new Map(this._data);
        ac._data.delete(addrObj.address);
        return ac;
    }
    sort(fn) {
        let arr = [...this];
        arr = arr.sort(fn);
        return AddressSet.fromArray(arr);
    }
    toArray() {
        return [...this._data.values()];
    }
    toRedactedJSON() {
        return this.toArray().map((addr) => addr.toRedactedJSON());
    }
    toAddressStrings() {
        return [...this._data.keys()];
    }
    toString() {
        return [...this._data.keys()].join(', ');
    }
    union(otherSet) {
        const arr1 = [...this];
        const arr2 = [...otherSet];
        const both = [...arr1, ...arr2];
        return AddressSet.fromArray(both);
    }
    [Symbol.iterator]() {
        return this._data.values();
    }
    get size() {
        return this._data.size;
    }
    static PATH_SORTER = (a1, a2) => {
        const p1 = a1.pathArray;
        const p2 = a2.pathArray;
        if (p1[0] < p2[0])
            return -1;
        if (p1[0] > p2[0])
            return 1;
        if (p1[0] === p2[0]) {
            if (p1[1] < p2[1])
                return -1;
            if (p1[1] > p2[1])
                return 1;
            return 0;
        }
        return 0;
    };
}
